// @file Helper methods to interface with the surface DOM
import type { Id } from 'types'

export const postListDomId = 'wish-list'

export function sectionDomId(sectionId: Id): string {
  return `section-${sectionId}`
}

export const scrollToSectionId = (sectionId: Id, options = { smooth: true, centralize: false }): void => {
  const sectionEl = document.getElementById(sectionDomId(sectionId))
  if (!sectionEl) return

  const containerEl = document.getElementById(postListDomId)
  if (!containerEl) return

  let xCoordinate = sectionEl.offsetLeft
  if (options.centralize) {
    const extraSpace = Math.max(containerEl.clientWidth - sectionEl.scrollWidth, 0)
    xCoordinate = xCoordinate - extraSpace / 2
  }

  const originalScrollBehavior = containerEl.style.scrollBehavior
  containerEl.style.scrollBehavior = options.smooth ? 'smooth' : 'auto'
  containerEl.scroll(xCoordinate, 0)
  containerEl.style.scrollBehavior = originalScrollBehavior
}
